/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useState } from 'react';
import { AlertDialog, Button, Field, Input, RadioGroup, Text } from '@components/design-system';
import * as Styles from '@components/modals/styles';
import { swapCollect } from '@lib/beacon';
import { MutToTez } from '@utils/format';
import { calculateAdvancedSwapPrice } from '@utils/math';

export interface ISwapSlippage {
  open?: boolean;
  onOpenChange?: (value: boolean) => void;
  swapId?: number;
  startPrice?: number;
  endPrice?: number;
  amount?: number;
  amountLeft?: number;
  creatorsTotal?: number;
}

enum SLIPPAGE {
  ZERO = '0',
  ONE = '1',
  TWO = '2',
  FOUR = '4',
  EIGHT = '8',
}

export const SwapSlippage: FC<ISwapSlippage> = ({
  open,
  onOpenChange,
  swapId,
  startPrice,
  endPrice,
  amount,
  amountLeft,
  creatorsTotal,
}) => {
  const [slippage, setSlippage] = useState(SLIPPAGE.ZERO as string);

  const current = calculateAdvancedSwapPrice(startPrice!, endPrice!, amount!, amountLeft!);
  const withSlippage = calculateAdvancedSwapPrice(startPrice!, endPrice!, amount!, amountLeft!, Number(slippage));
  const handleChangeMode = (nextMode: string) => {
    setSlippage(nextMode);
  };

  const handleConfirm = () => {
    swapCollect(swapId!, withSlippage, 1, creatorsTotal);

    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  const handleCancel = () => {
    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  return (
    <AlertDialog
      title="Advanced Swap"
      description="Adjust swap slippage"
      open={open}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    >
      <Styles.Content>
        <Field uid="slippage" label="Slippage" tooltip="Slippage multiplier. The higher the better">
          <>
            <RadioGroup
              value={slippage}
              onChange={handleChangeMode}
              data={[
                {
                  key: SLIPPAGE.ZERO,
                  label: 'x0',
                },
                {
                  key: SLIPPAGE.ONE,
                  label: 'x1',
                },
                {
                  key: SLIPPAGE.TWO,
                  label: 'x2',
                },
                {
                  key: SLIPPAGE.FOUR,
                  label: 'x4',
                },
                {
                  key: SLIPPAGE.EIGHT,
                  label: 'x8',
                },
              ]}
            />
            <Text css={{ color: '$secondaryFill', fontSize: 14 }}>
              Read more{' '}
              <Button
                as="a"
                variant="underline"
                href="https://docs.versum.xyz/faq/slippage/"
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </Button>
              .
            </Text>
          </>
        </Field>

        <Field uid="current" label="Current price" tooltip="This is the current price">
          <Input type="number" value={MutToTez(current)} disabled />
        </Field>

        <Field uid="with-slippage" label="Price with slippage" tooltip="This is the adjusted price">
          <Input type="number" value={MutToTez(withSlippage)} disabled />
        </Field>
      </Styles.Content>
    </AlertDialog>
  );
};
